<template>
    <div v-loading="loading" class="suobi-chongzhi">
        <div class="chongzhi-card">
            <div class="card-header">
                <div class="tit">选择充值数额</div>
            </div>
            <div class="card-body">
                <div class="amount-list">
                    <div v-for="(item, index) in list.arr" :key="index" :class="list.active == index ? 'active' : ''"
                        @click="list.active = index">
                        <div class="amount">{{ item }}</div>
                        <span class="label">缩币</span>
                        <span class="price">￥{{ item }}.00</span>
                    </div>
                </div>
                <div class="custom-input">
                    <el-input placeholder="请输入自定义充值金额" v-model="price" clearable>
                    </el-input>
                </div>
                <div class="pay-methods">
                    <span class="method-item" @click="pay('wxpay')">
                        <span class="icon">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path
                                    d="M8.691 2.188C3.891 2.188 0 5.476 0 9.53c0 2.212 1.17 4.203 3.002 5.55a.59.59 0 0 1 .213.665l-.39 1.48c-.019.07-.048.141-.048.213 0 .163.13.295.29.295a.326.326 0 0 0 .167-.054l1.903-1.114a.864.864 0 0 1 .717-.098 10.16 10.16 0 0 0 2.837.403c4.801 0 8.692-3.287 8.692-7.342 0-4.054-3.891-7.339-8.692-7.339z" />
                            </svg>
                        </span>
                        <span>微信支付</span>
                    </span>
                    <span class="method-item" @click="pay('alipay')">
                        <span class="icon">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path
                                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z" />
                            </svg>
                        </span>
                        <span>支付宝</span>
                    </span>
                </div>
            </div>
        </div>

        <div class="instructions-card">
            <div class="card-header">
                <div class="tit">缩水网充值说明</div>
            </div>
            <div class="card-body">
                <ul>
                    <li>1. 不能购彩和提现，仅用于查看缩水师推荐缩水单，技巧师推荐EXCEL表、软件交易师的软件以及投注站帮扶中心众筹招股，最少充值100元(1元=1缩币)</li>
                    <li>2. 微信客服：hzck36886</li>
                    <li>3. 微信月限额5000元，支付宝月限额1000元。额度用完后，可以用银行汇款转账到公司其他账号继续充值</li>
                    <li>4. 银行汇款转账方式充值：我们收到汇款后，管理员会帮您充值缩币</li>
                    <li>5. 查询记录：请在个人中心查看缩币记录</li>
                    <li>6. 欢迎联系我们(8:30-21:30)，夜间21:30~8:30无人工客服，请微信或QQ留言</li>
                </ul>
            </div>
        </div>

        <el-dialog :visible.sync='qrCode.show' :title="''" :show-header="false" width="520px" @close="handleQrClose">
            <div class="qr-container">
                <div class="pay-header">
                    <div class="pay-title">{{ payTitle }}</div>
                    <div class="pay-desc">请使用{{ payTitle === '微信支付' ? '微信' : '支付宝' }}扫描二维码支付</div>
                </div>
                <div class="amount-display">支付金额：{{ price || list.arr[list.active] }}元</div>
                <div class="qr-wrapper">
                    <div ref="qrcode" class="qr-code"></div>
                </div>
                <div class="tips">
                    <div class="tip-title">温馨提示</div>
                    <div class="tip-content">
                        支付成功后系统会自动为您充值，请耐心等待...
                        <br/>
                        <!-- 【P1-6 修复】剩余时间 + 主动查询 + 联系客服 -->
                        <span v-if="remainTime > 0" class="remain-time">
                            二维码有效期剩余：<b>{{ formatRemainTime(remainTime) }}</b>
                        </span>
                        <span v-else class="timeout-text" style="color:#E92728;font-weight:bold">
                            二维码已过期，请关闭后重新发起支付
                        </span>
                    </div>
                </div>

                <!-- 【P1-6 修复】操作按钮区 -->
                <div class="pay-actions">
                    <el-button type="primary" icon="el-icon-refresh" size="small" @click="queryPayStatus" :loading="queryLoading" :disabled="remainTime <= 0">
                        查询支付结果
                    </el-button>
                    <el-button type="text" size="small" @click="showContactTip">
                        遇到问题？联系客服
                    </el-button>
                </div>

                <!-- 【P1-6 修复】连接状态提示 -->
                <div v-if="wsStatus === 'connecting'" class="status-tip status-connecting">
                    <i class="el-icon-loading"></i> 正在连接支付服务...
                </div>
                <div v-else-if="wsStatus === 'polling'" class="status-tip status-polling">
                    <i class="el-icon-info"></i> 实时连接不可用，已切换为自动查询模式
                </div>
                <div v-else-if="wsStatus === 'connected'" class="status-tip status-connected">
                    <i class="el-icon-success"></i> 支付服务已连接，正在等待支付结果
                </div>
            </div>
        </el-dialog>

    </div>
</template>

<script>
import { balance, record } from '@/api/chongzhi'
import QRCode from 'qrcodejs2';
export default {
    data() {
        return {
            payTitle: '',
            price: '',
            list: {
                active: 0,
                arr: [5, 15, 30, 50, 100, 200, 500, 1000]
            },
            qrCode: {
                show: false,
                url: ''
            },
            loading: false,

            socket: null, // Socket连接对象
            ws: {},

            // 【P1-6 修复】支付状态管理
            currentOrderNo: '',     // 当前订单号（用于轮询）
            payAmount: 0,           // 当前支付金额（用于比对充值记录）
            pollTimer: null,        // 轮询定时器
            remainTimer: null,      // 倒计时定时器
            remainTime: 900,        // 二维码有效期（秒），默认15分钟
            queryLoading: false,    // 查询中状态
            wsStatus: 'disconnected', // WebSocket 状态：disconnected/connecting/connected/polling
            paySuccess: false,      // 支付是否成功
        }
    },
    mounted() {

    },
    beforeDestroy() {
        // 【P1-6 修复】组件销毁时清理所有定时器和连接
        this.cleanupPayResources()
    },
    methods: {
        // 【P1-6 修复】清理支付相关资源
        cleanupPayResources() {
            // 关闭 WebSocket
            if (this.ws && this.ws.readyState === WebSocket.OPEN) {
                this.ws.close()
            }
            this.ws = {}
            // 清除轮询定时器
            if (this.pollTimer) {
                clearInterval(this.pollTimer)
                this.pollTimer = null
            }
            // 清除倒计时定时器
            if (this.remainTimer) {
                clearInterval(this.remainTimer)
                this.remainTimer = null
            }
            this.wsStatus = 'disconnected'
        },

        // 【P1-6 修复】二维码弹窗关闭时清理资源
        handleQrClose() {
            if (!this.paySuccess) {
                this.cleanupPayResources()
            }
        },

        // 【P1-6 修复】格式化剩余时间
        formatRemainTime(seconds) {
            const min = Math.floor(seconds / 60)
            const sec = seconds % 60
            return `${min}分${sec.toString().padStart(2, '0')}秒`
        },

        // 【P1-6 修复】联系客服提示
        showContactTip() {
            this.$alert('如有支付问题，请联系微信客服：hzck36886', '联系客服', {
                confirmButtonText: '知道了',
                type: 'info'
            })
        },

        // 【P1-6 修复】启动倒计时
        startRemainCountdown() {
            this.remainTime = 900 // 15分钟
            if (this.remainTimer) {
                clearInterval(this.remainTimer)
            }
            this.remainTimer = setInterval(() => {
                this.remainTime--
                if (this.remainTime <= 0) {
                    clearInterval(this.remainTimer)
                    this.remainTimer = null
                    // 超时了，停止轮询
                    if (this.pollTimer) {
                        clearInterval(this.pollTimer)
                        this.pollTimer = null
                    }
                }
            }, 1000)
        },

        // 【P1-6 修复】启动支付状态轮询（兜底机制）
        startPolling() {
            // 先停止之前的轮询
            if (this.pollTimer) {
                clearInterval(this.pollTimer)
            }

            // 前30秒每5秒查一次，之后每10秒查一次
            let pollCount = 0
            const fastInterval = 5000   // 5秒
            const slowInterval = 10000  // 10秒
            const maxFastPolls = 6      // 30秒 / 5秒 = 6次

            const doPoll = async () => {
                if (this.remainTime <= 0 || this.paySuccess) {
                    clearInterval(this.pollTimer)
                    this.pollTimer = null
                    return
                }

                try {
                    await this.doQueryPayStatus()
                } catch (e) {
                    // 查询失败忽略，继续下一轮
                    console.warn('支付状态轮询失败', e)
                }

                pollCount++
                // 前6次快速轮询后，切换为慢速
                if (pollCount === maxFastPolls) {
                    clearInterval(this.pollTimer)
                    this.pollTimer = setInterval(doPoll, slowInterval)
                }
            }

            this.pollTimer = setInterval(doPoll, fastInterval)
        },

        // 【P1-6 修复】执行支付状态查询
        // 通过查询充值记录，比对金额和时间来判断最近一笔是否成功
        async doQueryPayStatus() {
            try {
                const res = await record({ pageNum: 1, pageSize: 5 })
                if (res && res.code === 200 && res.data && res.data.records) {
                    const records = res.data.records
                    // 找到最近一笔金额匹配且状态为成功的充值记录
                    const targetAmount = this.payAmount
                    const now = Date.now()
                    const successRecord = records.find(r => {
                        // 金额匹配（转为数字比较，容忍小数精度）
                        const amountMatch = Math.abs(parseFloat(r.money || r.amount) - targetAmount) < 0.01
                        // 状态为成功（不同系统字段名可能不同，做兼容）
                        const statusSuccess = r.status === '1' || r.status === 200 || r.payStatus === '1' || r.payStatus === 200 || r.rechargeStatus === '1'
                        // 时间在最近15分钟内
                        const createTime = r.createTime ? new Date(r.createTime).getTime() : 0
                        const timeMatch = (now - createTime) < 15 * 60 * 1000
                        return amountMatch && statusSuccess && timeMatch
                    })

                    if (successRecord) {
                        // 支付成功！
                        this.handlePaySuccess()
                    }
                }
            } catch (e) {
                // 静默处理，轮询会继续
                console.warn('查询充值记录失败', e)
            }
        },

        // 【P1-6 修复】主动查询支付结果（用户点击按钮）
        async queryPayStatus() {
            if (this.remainTime <= 0) return
            this.queryLoading = true
            try {
                await this.doQueryPayStatus()
                if (!this.paySuccess) {
                    this.$message.info('暂未查询到支付结果，请稍后再试')
                }
            } catch (e) {
                this.$message.error('查询失败，请稍后重试')
            } finally {
                this.queryLoading = false
            }
        },

        // 【P1-6 修复】统一处理支付成功
        handlePaySuccess() {
            if (this.paySuccess) return
            this.paySuccess = true
            this.qrCode.show = false
            this.cleanupPayResources()
            this.$alert('支付成功', '提示', {
                confirmButtonText: '确定',
                type: 'success'
            });
            this.price = ''
        },

        pay(payType) {
            const amount = this.price || this.list.arr[this.list.active]
            this.payAmount = parseFloat(amount)
            this.paySuccess = false

            let params = `/${this.vuex_token}?userId=${this.vuex_userInfo.userId}&businessType=pay`

            // 【P1-6 修复】重置状态
            this.wsStatus = 'connecting'

            this.ws = new WebSocket(process.env.VUE_APP_BASE_WS + '/stage-api/pay-websocket' + params)

            // 【P1-6 修复】WebSocket 连接超时（5秒未连上则降级为轮询）
            const wsConnectTimeout = setTimeout(() => {
                if (this.ws.readyState !== WebSocket.OPEN) {
                    console.warn('WebSocket 连接超时，降级为 HTTP 轮询模式')
                    this.wsStatus = 'polling'
                    // 关闭尝试中的连接
                    try { this.ws.close() } catch(e) {}
                    // 启动轮询兜底
                    this.startPolling()
                }
            }, 5000)

            this.ws.onopen = (event) => {
                console.log("WebSocket is open now.")
                clearTimeout(wsConnectTimeout)
                this.wsStatus = 'connected'
            }

            let that = this
            this.ws.onmessage = function (event) {
                console.log("Message from server ", event.data);
                let { code, msg } = JSON.parse(event.data)
                if (code == 200) {
                    that.qrCode.show = false
                }
                if (msg == '支付成功') {
                    that.handlePaySuccess()
                }
            }

            // 【P1-6 修复】WebSocket 错误时降级为轮询
            this.ws.onerror = (event) => {
                console.error('WebSocket 连接错误', event)
                clearTimeout(wsConnectTimeout)
                if (this.wsStatus !== 'polling' && !this.paySuccess) {
                    this.wsStatus = 'polling'
                    this.startPolling()
                }
            }

            // 【P1-6 修复】WebSocket 关闭时，如果还没成功，启动轮询兜底
            this.ws.onclose = (event) => {
                console.log('WebSocket 连接关闭', event)
                clearTimeout(wsConnectTimeout)
                if (this.wsStatus !== 'polling' && !this.paySuccess) {
                    this.wsStatus = 'polling'
                    this.startPolling()
                }
            }

            this.loading = true
            balance({
                money: amount,
                payType,
                userName: this.vuex_userInfo.nickName,
                returnUrl: 'http://www.baidu.com'
            }).then(res => {
                this.loading = false
                this.qrCode.show = true

                this.payTitle = payType == 'wxpay' ? '微信支付' : '支付宝支付'

                // 【P1-6 修复】记录订单号（如果有返回的话）
                if (res && res.data && res.data.orderNo) {
                    this.currentOrderNo = res.data.orderNo
                }

                this.$nextTick(_ => {
                    const container = this.$refs.qrcode;
                    while (container.firstChild) {
                        container.removeChild(container.firstChild);
                    }
                    new QRCode(this.$refs.qrcode, {
                        text: res.data.codeUrl,
                        width: 128 * 2,
                        height: 128 * 2
                    });
                })

                // 【P1-6 修复】启动倒计时 + 兜底轮询
                this.startRemainCountdown()
                // 如果 WebSocket 还没连上，轮询会在超时后启动
                // 如果已经连上，也启动一轮慢轮询作为兜底（延迟10秒后启动）
                setTimeout(() => {
                    if (!this.paySuccess && !this.pollTimer && this.qrCode.show) {
                        // WS 连接成功也启动慢速轮询作为双保险
                        this.startPolling()
                    }
                }, 10000)

            }).catch(err => {
                // 【P1 修复】创建订单失败处理
                console.error('创建支付订单失败', err)
                this.loading = false
                this.cleanupPayResources()
                // 全局错误提示已在 http.js 中弹出
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.suobi-chongzhi {
    width: 100%;
    box-sizing: border-box;

    .chongzhi-card,
    .instructions-card {
        background: #fff;
        border-radius: 12px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
        overflow: hidden;
        margin-bottom: 20px;

        .card-header {
            background: linear-gradient(135deg, #2899DF 0%, #1a7fc4 100%);
            padding: 14px 20px;

            .tit {
                color: #fff;
                font-weight: bold;
                font-size: 16px;
            }
        }

        .card-body {
            padding: 20px;
        }
    }

    .amount-list {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 15px;
        margin-bottom: 20px;

        >div {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 15px 10px;
            background: #FFB74D;
            border-radius: 10px;
            cursor: pointer;
            transition: all 0.3s ease;

            &:hover {
                transform: scale(1.02);
            }

            &.active {
                background: #E92728;
            }

            .amount {
                font-size: 24px;
                font-weight: bold;
                color: #fff;
            }

            .label {
                font-size: 12px;
                color: rgba(255, 255, 255, 0.85);
                margin-top: 4px;
            }

            .price {
                font-size: 14px;
                color: rgba(255, 255, 255, 0.9);
                margin-top: 6px;
            }
        }
    }

    .custom-input {
        margin-bottom: 25px;

        :deep(.el-input__wrapper) {
            border-radius: 8px;
            border-color: #e8e8e8;
            transition: all 0.3s;

            &:focus-within {
                border-color: #2899DF;
                box-shadow: 0 0 0 2px rgba(40, 153, 223, 0.1);
            }
        }
    }

    .pay-methods {
        display: flex;
        gap: 50px;

        .method-item {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 10px;
            padding: 12px 50px;
            background: #409eff;
            border-radius: 10px;
            cursor: pointer;
            transition: all 0.3s ease;

            &:hover {
                opacity: 0.9;
            }

            .icon {
                width: 24px;
                height: 24px;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #fff;

                svg {
                    width: 20px;
                    height: 20px;
                }
            }

            span:last-child {
                font-size: 16px;
                color: #fff;
                font-weight: 500;
            }
        }
    }

    .instructions-card {
        background: linear-gradient(135deg, #fff 0%, #f8fafc 100%);
        border-radius: 16px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
        overflow: hidden;
        margin-bottom: 20px;
        border: 1px solid #e8eef3;

        .card-header {
            background: linear-gradient(135deg, #409eff 0%, #2d8cf0 100%);
            padding: 18px 24px;

            .tit {
                color: #fff;
                font-size: 16px;
                font-weight: 600;
                letter-spacing: 0.5px;
                text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
            }
        }

        .card-body {
            padding: 24px;

            ul {
                margin: 0;
                padding: 0;
                list-style: none;

                li {
                    line-height: 2;
                    font-size: 14px;
                    color: #4a5568;
                    padding-left: 22px;
                    position: relative;
                    margin-bottom: 12px;

                    &:last-child {
                        margin-bottom: 0;
                    }

                    &::before {
                        // 用 element-icons 字体的对勾字形（\e6da），避免 ✓ 在部分设备显示为豆腐块
                        content: "\e6da";
                        font-family: element-icons !important;
                        position: absolute;
                        left: 0;
                        color: #409eff;
                        font-size: 14px;
                        font-weight: bold;
                    }
                }
            }
        }
    }

    .qr-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0;
        min-height: 450px;
        background: linear-gradient(180deg, #f5f7fa 0%, #fff 50%);
        border-radius: 12px;
        overflow: hidden;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);

        .pay-header {
            width: 100%;
            background: linear-gradient(135deg, #409eff 0%, #2d8cf0 50%, #1e7de4 100%);
            padding: 30px;
            text-align: center;
            position: relative;
            overflow: hidden;

            &::before {
                content: '';
                position: absolute;
                top: -50%;
                right: -20%;
                width: 100px;
                height: 100px;
                background: rgba(255, 255, 255, 0.1);
                border-radius: 50%;
            }

            &::after {
                content: '';
                position: absolute;
                bottom: -30%;
                left: -15%;
                width: 80px;
                height: 80px;
                background: rgba(255, 255, 255, 0.08);
                border-radius: 50%;
            }

            .pay-title {
                font-size: 24px;
                font-weight: 600;
                color: #fff;
                margin-bottom: 8px;
                text-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
                letter-spacing: 1px;
            }

            .pay-desc {
                font-size: 14px;
                color: rgba(255, 255, 255, 0.9);
                font-weight: 400;
            }
        }

        .amount-display {
            font-size: 32px;
            font-weight: 700;
            color: #E92728;
            margin-bottom: 25px;
            padding: 20px 40px;
            background: linear-gradient(135deg, #fff5f5 0%, #ffeaea 100%);
            border-radius: 16px;
            border: 2px solid #ffd6d6;
            box-shadow: 0 4px 16px rgba(233, 39, 40, 0.15);
            position: relative;
            top: -10px;

            &::before {
                content: '';
                position: absolute;
                top: 4px;
                left: 4px;
                right: 4px;
                bottom: 4px;
                border: 1px dashed rgba(233, 39, 40, 0.2);
                border-radius: 12px;
            }
        }

        .qr-wrapper {
            background: #fff;
            padding: 30px;
            border-radius: 16px;
            box-shadow: 0 6px 24px rgba(0, 0, 0, 0.08);
            margin-bottom: 20px;
            border: 1px solid #e8eef3;
            transition: transform 0.3s ease, box-shadow 0.3s ease;

            &:hover {
                transform: translateY(-2px);
                box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
            }

            .qr-code {
                width: 260px;
                height: 260px;
                display: flex;
                align-items: center;
                justify-content: center;
                background: #fff;
                border-radius: 8px;
            }
        }

        .tips {
            text-align: center;
            padding: 20px 30px;
            background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
            border-radius: 12px;
            width: 90%;
            box-sizing: border-box;
            border: 1px solid #e2e8f0;
            margin-bottom: 15px;

            .tip-title {
                font-size: 14px;
                font-weight: 600;
                color: #334155;
                margin-bottom: 10px;
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 6px;

                &::before {
                    content: '💡';
                    font-size: 14px;
                }
            }

            .tip-content {
                font-size: 13px;
                color: #64748b;
                line-height: 1.8;
            }

            .remain-time {
                display: block;
                margin-top: 8px;
                font-size: 12px;
                color: #f59e0b;

                b {
                    color: #d97706;
                }
            }

            .timeout-text {
                display: block;
                margin-top: 8px;
                font-size: 13px;
            }
        }

        // 【P1-6 修复】操作按钮区
        .pay-actions {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 20px;
            margin-bottom: 20px;
        }

        // 【P1-6 修复】连接状态提示
        .status-tip {
            width: 90%;
            padding: 8px 16px;
            border-radius: 8px;
            font-size: 12px;
            text-align: center;            margin-bottom: 20px;
            box-sizing: border-box;

            i {
                margin-right: 4px;
            }

            &.status-connecting {
                background: #fef3c7;
                color: #92400e;
                border: 1px solid #fcd34d;
            }

            &.status-connected {
                background: #d1fae5;
                color: #065f46;
                border: 1px solid #6ee7b7;
            }

            &.status-polling {
                background: #dbeafe;
                color: #1e40af;
                border: 1px solid #93c5fd;
            }
        }
    }
}

/* ===== 移动端适配（屏幕小于 1200px 即生效） ===== */
@media (max-width: 1200px) {
    .suobi-chongzhi {

        .chongzhi-card,
        .instructions-card {

            .card-header {
                padding: 12px 14px;

                .tit {
                    font-size: 15px;
                }
            }

            .card-body {
                padding: 14px;
            }
        }

        /* 充值金额：改两列排列，字号收小 */
        .amount-list {
            grid-template-columns: repeat(2, 1fr);
            gap: 10px;
            margin-bottom: 14px;

            >div {
                padding: 12px 6px;

                .amount {
                    font-size: 20px;
                }
            }
        }

        /* 支付方式：两个入口紧凑排列 */
        .pay-methods {
            gap: 12px;

            .method-item {
                padding: 12px 8px;
                gap: 6px;

                span:last-child {
                    font-size: 15px;
                }
            }
        }

        /* 充值说明 */
        .instructions-card .card-body {

            ul li {
                font-size: 13px;
                line-height: 1.9;
                padding-left: 20px;
                margin-bottom: 10px;
            }
        }

        /* 支付弹窗：二维码区域整体收窄 */
        .qr-container {
            min-height: 0;

            .pay-header {
                padding: 20px 16px;

                .pay-title {
                    font-size: 20px;
                }
            }

            .amount-display {
                font-size: 24px;
                padding: 14px 20px;
                margin-bottom: 18px;
            }

            .qr-wrapper {
                padding: 16px;

                .qr-code {
                    width: 200px;
                    height: 200px;

                    /* 二维码由 qrcodejs2 生成 256px，这里等比缩小以适配窄屏 */
                    canvas,
                    img {
                        width: 200px !important;
                        height: 200px !important;
                    }
                }
            }

            .tips {
                width: 100%;
                padding: 14px 16px;
            }

            .pay-actions {
                gap: 10px;
                flex-wrap: wrap;
                padding: 0 12px 16px;
            }

            .status-tip {
                width: 100%;
                box-sizing: border-box;
            }
        }
    }
}
</style>
